"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _trayMenu = _interopRequireDefault(require("@ux/tray-menu"));
require("@ux/tray-menu/styles");
var _util = require("@ux/util");
var _golfToEid = _interopRequireDefault(require("@gd-internal/golf-to-eid"));
var _reactMintl = require("@godaddy/react-mintl");
var _atlas = require("@godaddy/atlas");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const loadCurrenciesFromAtlas = (atlasEnv, privateLabelId, marketLocale, done) => {
  // Determine environment from hostname if needed
  if (!atlasEnv) {
    var _ref;
    const hostname = (_ref = typeof window !== 'undefined') !== null && _ref !== void 0 ? _ref : window.location.hostname;
    if (hostname) {
      atlasEnv = (0, _atlas.envFromHostname)(hostname);
    }
  }
  atlasEnv ??= 'prod';

  // Build Atlas instance for the environment
  _atlas.Atlas.builder(atlasEnv).build().then(atlas => {
    // Resolve market of brand using private label ID
    const brand = atlas.resolveBrandByPlid(privateLabelId);
    const market = brand.resolveMarketByLocale(marketLocale);

    // Extract currencies specific to this market
    const priority = market.getCurrencies();

    // Create set of market currency codes for filtering
    const codes = new Set(priority.map(c => c.code));

    // Filter out market currencies from all available currencies
    const standard = atlas.allCurrencies.filter(c => !codes.has(c.code));

    // Combine market currencies, divider, and other currencies
    const results = [priority, standard];
    done(null, results);
  }).catch(err => done(err));
};

/**
 * Render and expose the CurrencySelector as a functional Component. The CurrencySelector
 * is responsible for allowing users to select their desired money. The default values
 * populated and the ordering of currencies within the list are dependent on the current
 * market and any previous user state.
 *
 * @param {Object} props Properties
 * @api public
 */
class CurrencySelector extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      priorityCurrencies: [],
      currencies: [],
      selected: '',
      loaded: false
    };
  }

  /**
   * Function that gets called when user clicks on a currency item
   *
   * @param {Currency} cur The currently selected currency object
   * @param {React.SyntheticEvent} event The event fired on click
   *
   * @api public
   */
  onCurrencyChanged(cur, event) {
    event.preventDefault();
    this.setState({
      currency: cur,
      selected: cur.code
    });
    this.tray.close();
    if (typeof document === 'undefined') {
      return;
    }
    this.doCurrencyRedirect(cur);
  }

  /**
   * Do currency redirect once set
   *
   * @param {Currency} cur The currently selected currency object
   */
  doCurrencyRedirect(cur) {
    const {
      isReseller,
      urls,
      privateLabelId
    } = this.props;
    if (isReseller) {
      const url = new _util.URL(urls.currencyList.href, true);
      url.set('query', _objectSpread(_objectSpread({}, url.query), {}, {
        currency: cur.code,
        target: window.location.href
      }));
      window.location.assign(url.href);
      return;
    }
    const requestUrl = new _util.URL(urls.currencyList.href + '/' + cur.code);
    const query = {};
    if (privateLabelId !== 1) {
      query.pl_id = privateLabelId;
    }
    requestUrl.set('query', query);
    _util.request.get(requestUrl.href, {}, err => {
      if (err) {
        return;
      }
      const redirectUrl = new _util.URL(window.location.href, true);
      if (redirectUrl.query.currency) {
        // strip `currencyType` query
        redirectUrl.set('query', _objectSpread(_objectSpread({}, redirectUrl.query), {}, {
          currency: ''
        }));
        // If the URL is changing, we must truly redirect to it
        window.location.assign(redirectUrl.href);
      } else {
        // If the URL is the same, we can simply reload, so that hash URLs work
        window.location.reload(true);
      }
    });
  }

  /**
   * @typedef {Object} Currency
   * @prop {string} code Currency code (e.g. USD, EUR)
   * @prop {string} symbol Currency symbol (e.g. $, £, ¥)
   */
  /**
   * Performs lexographic sorts based on the `code` key.
   * @param {Currency} lcur LHS of the sort to compare.
   * @param {Currency} rcur RHS of the sort to compare.
   * @returns {Number} A value indicating if `lcur.code` is greater than,
   * less than, or equal to `rcur.code`.
   * @api private
   */
  sortByCode(lcur, rcur) {
    const lcode = lcur.code;
    const rcode = rcur.code;
    if (lcode === rcode) {
      return 0;
    }
    return lcode > rcode ? 1 : -1;
  }

  /**
   * Perform an AJAX call to the GUI service and pass the set
   * the currencies represented by the results on this instance.
   * @param {Function} [done] Optional continuation callback
   * @api public
   */
  fetchCurrencies(done) {
    // ux.eldorado.data.currency passed in by CMS
    let selected = this.props.currency;
    // string value of the `currency` cookie
    const currencyCookie = _util.cookie.get('currency');
    const {
      market,
      privateLabelId
    } = this.props;
    this.getCurrencies(this.props.env, market, privateLabelId, (err, currencyGroups) => {
      if (err) {
        return;
      }
      // validate selected
      currencyGroups.flat().forEach(curr => {
        if (curr.code === currencyCookie) {
          selected = curr.code;
        }
      });
      const [priority, standard] = currencyGroups;
      this.setCurrencies(priority, standard, selected, done);
    });
  }

  /**
   * @callback getCurrenciesCallback
   * @param {Object} err Error object
   * @param {Array<Currency>} currencies An array of currencies
   */
  /**
   * Wrapper around getCurrencies to allow easier stubbing in tests
   * @param {string} atlasEnv Atlas environment
   * @param {string} marketLocale Market code
   * @param {number} privateLabelId Private label ID
   * @param {getCurrenciesCallback} done Continuation callback
   */
  getCurrencies(atlasEnv, marketLocale, privateLabelId, done) {
    loadCurrenciesFromAtlas(atlasEnv, privateLabelId, marketLocale, done);
  }

  /**
   * Populate state with a list of currencies (from the Markets API).
   * @param {Currency[]} marketCurrencies List of market's currencies (e.g. { code: CAD, symbol: '$' })
   * @param {Currency[]} otherCurrencies List of remaining currencies (e.g. { code: CAD, symbol: '$' })
   * @param {string} selectedCode The currency code of the currency selected by the currency cookie
   * @param {Function} [done] Optional continuation callback
   * @api private
   */
  setCurrencies(marketCurrencies, otherCurrencies, selectedCode, done) {
    // separate out priority currency (first in list)
    this.setState({
      currencies: otherCurrencies,
      priorityCurrencies: marketCurrencies,
      selected: selectedCode || 'USD',
      loaded: true
    }, done);
  }

  /**
   * Fetches the list of currencies from the GUI service if no
   * currencies are present.
   * @api private
   */
  componentDidMount() {
    const {
      loaded
    } = this.state;
    if (typeof document !== 'undefined' && !loaded) {
      this.fetchCurrencies();
    }
  }

  /**
   * Renders the CurrencySelector as a TrayMenu composed of two sets
   * of CurrencyItems:
   * - priorityCurrencies: currencies that should be displayed first.
   * - currencies: all other currencies available to transact in.
   *
   * @returns {React.ReactElement} Virtual DOM for the CurrencySelector
   * @api public
   */
  render() {
    // Do not render anything if the currencies are not yet fetched
    if (!this.state.loaded) return null;
    const {
      currencies,
      priorityCurrencies,
      selected
    } = this.state;
    const {
      eidPrefix,
      messages
    } = this.props;
    const trayMenuClassNames = (0, _classnames.default)('currency-selector', 'currency-selector-fade', {
      ['currency-selector-in']: this.state.loaded
    });
    const eid = (0, _golfToEid.default)('CurrencySelector', {
      prefix: eidPrefix,
      postfix: 'click'
    });
    return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
      messages: messages
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Sales:Footer:CurrencySelector:Label",
      values: {
        selection: selected
      }
    }, content => /*#__PURE__*/_react.default.createElement(_trayMenu.default, {
      ariaLabel: content,
      name: selected,
      type: "base",
      className: trayMenuClassNames,
      ref: c => this.tray = c,
      "data-eid": eid
    }, priorityCurrencies.map(cur => {
      const classNames = (0, _classnames.default)('currency-item', {
        selected: selected === cur.code
      });
      return /*#__PURE__*/_react.default.createElement(CurrencyItem, {
        key: `priority-${cur.code}`,
        code: cur.code,
        symbol: cur.symbol,
        className: classNames,
        eidPrefix: eidPrefix,
        onClick: this.onCurrencyChanged.bind(this, cur)
      });
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "divider"
    }), currencies.map(cur => {
      const classNames = (0, _classnames.default)('currency-item', {
        selected: selected === cur.code
      });
      return /*#__PURE__*/_react.default.createElement(CurrencyItem, {
        key: `currency-${cur.code}`,
        code: cur.code,
        symbol: cur.symbol,
        className: classNames,
        eidPrefix: eidPrefix,
        onClick: this.onCurrencyChanged.bind(this, cur)
      });
    }))));
  }
}

/*
 * PropTypes for the CurrencySelector. `urls.gui` is the only
 * required URL.
 */
CurrencySelector.propTypes = {
  messages: _propTypes.default.object.isRequired,
  currency: _propTypes.default.string,
  eidPrefix: _propTypes.default.string,
  urls: _propTypes.default.object.isRequired,
  market: _propTypes.default.string.isRequired,
  privateLabelId: _propTypes.default.number.isRequired,
  isReseller: _propTypes.default.bool,
  /* Atlas environment */
  env: _propTypes.default.string
};
CurrencySelector.defaultProps = {
  eidPrefix: 'uxp.hyd'
};
var _default = exports.default = CurrencySelector;
/**
 * Internal helper component for displaying a single currency in the
 * CurrencySelector dropdown.
 *
 * @param {Object} props Properties
 * @returns {React.ReactNode} react component
 * @api private
 */
function CurrencyItem({
  code,
  symbol,
  eidPrefix,
  onClick,
  className
}) {
  /**
   * Invokes this.props.onClick with the code and symbol
   * of the currency associated with this instance.
   *
   * @param {React.SyntheticEvent} evt React Click event.
   */
  function _onClick(evt) {
    onClick(evt, {
      code,
      symbol
    });
  }
  const eid = (0, _golfToEid.default)(code, {
    prefix: eidPrefix + '.currency_selector',
    postfix: 'click'
  });
  const ariaLabelCurrency = code + ', ' + symbol;
  return /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: className,
    onClick: _onClick,
    "data-eid": eid,
    "aria-label": ariaLabelCurrency
  }, /*#__PURE__*/_react.default.createElement("span", null, code), " ", /*#__PURE__*/_react.default.createElement("span", null, symbol));
}

/*
 * PropTypes for the CurrencySelector.
 * Only `className` is optional.
 */
CurrencyItem.propTypes = {
  className: _propTypes.default.string,
  eidPrefix: _propTypes.default.string.isRequired,
  code: _propTypes.default.string.isRequired,
  symbol: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func.isRequired
};